import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  line-height: 1.2;\n'], ['\n  align-items: center;\n  display: flex;\n  line-height: 1.2;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 18px;\n  margin-right: 8px;\n'], ['\n  font-size: 18px;\n  margin-right: 8px;\n']);

import React from 'react';
import styled from 'styled-components';

import { groupedCountries } from './data/countries';
import Select from './Select';

// flow stuff


// custom option renderer
var Label = styled.div(_templateObject);
var Flag = styled.span(_templateObject2);
var Opt = function Opt(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return React.createElement(
    Label,
    null,
    React.createElement(
      Flag,
      null,
      icon
    ),
    children
  );
};

// return the country name; used for searching
var getOptionLabel = function getOptionLabel(opt) {
  return opt.name;
};

// set the country's abbreviation for the option value, (also searchable)
var getOptionValue = function getOptionValue(opt) {
  return opt.abbr;
};

// the text node of the control
var controlLabel = function controlLabel(opt) {
  return React.createElement(
    Opt,
    { icon: opt.icon },
    opt.abbr.toUpperCase()
  );
};
// the text node for an option
var optionLabel = function optionLabel(_ref2) {
  var abbr = _ref2.abbr,
      code = _ref2.code,
      icon = _ref2.icon,
      name = _ref2.name;
  return React.createElement(
    Opt,
    { icon: icon },
    name,
    ' (',
    abbr.toUpperCase(),
    ') +',
    code
  );
};

// switch formatters based on render context (menu | value)
var formatOptionLabel = function formatOptionLabel(opt, _ref3) {
  var context = _ref3.context;
  return context === 'value' ? controlLabel(opt) : optionLabel(opt);
};

// put it all together
var CountrySelect = function CountrySelect(props) {
  return React.createElement(Select
  // components={{ Menu }}
  , _extends({ isClearable: false,
    formatOptionLabel: formatOptionLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isMulti: false,
    options: groupedCountries,
    styles: {
      container: function container(css) {
        return _extends({}, css, { width: 105 });
      },
      dropdownIndicator: function dropdownIndicator(css) {
        return _extends({}, css, { paddingLeft: 0 });
      },
      menu: function menu(css) {
        return _extends({}, css, { width: 300 });
      }
    }
  }, props));
};

export default CountrySelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/CountrySelect.js
// module id = 501
// module chunks = 0